
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.815 15.334a6.519 6.519 0 100-13.037 6.519 6.519 0 000 13.037zm0 1.185a7.704 7.704 0 100-15.408 7.704 7.704 0 000 15.408z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.675 13.164a.77.77 0 011.088-.058l4.586 4.122a.77.77 0 11-1.03 1.146l-4.586-4.122a.77.77 0 01-.058-1.088z"}})])
          )
        }
      }
    